$(document).ready(function(){


   

    // Initiating first view
    setTimeout(function(){
        $('.ps_selection_cell[data-title="canvas"]').click();
        $('.product-template__container').addClass('loaded');
    },50);
    

    $('.ps_selection_cell').click(function(){

        $(this).closest('.ps_selection_grid').find('.ps_selection_cell').removeClass('active');
        $(this).closest('.ps_selection_depth_outer').find('.ps_selection_cell').removeClass('active');
        $(this).addClass('active');
        changeVariant();

        if ($(this).attr('data-title') == 'canvas'){
            $('.ps_selection_cell').each(function() {
                if ($(this).attr('data-title') == 'thin-wrap-0-75' ) {
                    $(this).click();
                }
                if ($(this).attr('data-title') == '8x8-in-20x20-cm' ) {
                    $(this).click();
                }
                if ($(this).attr('data-title') == 'black-frame' || $(this).attr('data-title') == 'white-frame' || $(this).attr('data-title') == 'print-only') {
                    $(this).addClass('disabled_variant');
                }
                else {
                    $(this).removeClass('disabled_variant')
                }
            });
            $('.ps_physical_pr').show();
            $('.ps_dig_info').hide();
        }
        else if ($(this).attr('data-title') == 'print'){
            $('.ps_selection_cell').each(function() {
                if ($(this).attr('data-title') == 'black-frame' ) {
                    $(this).click();
                }
                if ($(this).attr('data-title') == '12x18-in-30x45-cm' ) {
                    $(this).click();
                }
                if ($(this).attr('data-title') == 'thin-wrap-0-75' || $(this).attr('data-title') == 'thick-wrap-1-5' || $(this).attr('data-title') == '8x8-in-20x20-cm') {
                    $(this).addClass('disabled_variant');
                }
                else {
                    $(this).removeClass('disabled_variant')
                }
            });
            $('.ps_physical_pr').show();
            $('.ps_dig_info').hide();
        }
        else if ($(this).attr('data-title') == 'digital-file'){
            $('.ps_physical_pr').hide();
            $('.ps_dig_info').show();
        }
    });

    function changeVariant(){
        var fullTitle = '';
        $('.ps_selection_cell.active').each(function(){
            var currTitle = $(this).attr('data-title');
            fullTitle = fullTitle + '-' + currTitle;
        });

        fullTitle = fullTitle.substring(1);
        var currId;
        var newSource;
        
        $('.ps_price').hide();
        $('.ps_discount').hide();
        $('.ps_price').each(function(){
            if ($(this).attr('data-title') == fullTitle){
                currId = $(this).attr('data-id');
                $(this).css('display', 'flex');
                newSource = $(this).attr('data-src');
            }
        });
        $('.ps_discount[data-id="'+currId+'"]').show();

        $('.ps_main_variant_img__js').attr('src', newSource);
        $('.ps_gallery_main').slick('slickGoTo', 0);

        $('.product-form__variants').val(currId);

        var framingTitle = '';
        var sizeTitle = '';


      console.log(fullTitle);

        $('.ps_physical_pr').each(function(){
            var currentValue = $(this).find('.ps_selection_cell.active').attr('data-value');
            if (currentValue.indexOf('Thick') != -1 || currentValue.indexOf('Thin') != -1){
                framingTitle = currentValue + '") Canvas';
                currentValue = currentValue + '") Canvas';
            }
            else if (currentValue.indexOf('Black Frame') != -1 || currentValue.indexOf('White Fram') != -1 || currentValue.indexOf('Print') != -1){
                framingTitle = currentValue + ' Poster';
                currentValue = currentValue + ' Poster';
            }
            else{
                sizeTitle = currentValue;
            }
            $(this).find('.ps_selection_value').html(currentValue);
        });

        $('.product_framing_js').find('span').html(framingTitle);
        $('.product_size_js').find('span').html(sizeTitle);
    }

    setTimeout(function(){
        changeVariant();
    },500);
   
    


    $('.ps_gallery_main').slick({
    	slidesToShow: 1,
    	slidesToScroll: 1,
        adaptiveHeight: true, /* square and portrait photos mix; without this the slider is as tall as the tallest one */
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><div><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0570/0219/7151/files/Feather-arrows-chevron-right.svg?v=1717312246'/></div></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><div><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0570/0219/7151/files/Feather-arrows-chevron-right.svg?v=1717312246'/></div></button>",
        asNavFor: '.ps_gallery_main_thumb'
 	});

     $('.ps_gallery_main_thumb').slick({
    	slidesToShow: 4,
    	slidesToScroll: 1,
        arrows: false,
        focusOnSelect: true,
        asNavFor: '.ps_gallery_main'
 	});


    $('.pdp_expandable_block').click(function(event) {
        // If the clicked element is inside `.pdp_expandable_switch`, do nothing
        if ($(event.target).closest('.sizes_switch').length > 0) {
            return;
        }
    
        // Otherwise, toggle as usual
        $(this).toggleClass('active');
        $(this).find('.pdp_expandable_content').slideToggle();
    });

  $('.size_switch_btn').click(function(){
    var mode = $(this).attr('data');
    $('.size_switch_btn').removeClass('active');
    $(this).addClass('active');
    $('.sizes_images').find('img').hide();
    $('.sizes_images').find('img[data="'+mode+'"]').show();
  });


    $('.md_popup_close').click(function(){
        $('.md_ready_study_popup_out').hide();
    });


    $('.md_ready_study_popup_out').click(function(){
        $('.md_ready_study_popup_out').hide();
    });


    $('.ps_label_guide[data="size"]').click(function(){
        $('.md_ready_study_popup_out[data="size"]').css('display', 'flex');
    });

    $('.ps_label_guide[data="framing"]').click(function(){
        $('.md_ready_study_popup_out[data="framing"]').css('display', 'flex');
    });



    $('.image-container').on('mouseenter', function(event) {
        if ($(window).width() > 960) {
            var container = $(this);
            var img = container.find('img');
            
            // Save original image properties
            img.data('orig-width', img.width());
            img.data('orig-height', img.height());
            
            container.on('mousemove', function(event) {
            // Calculate mouse position relative to the container
            var mouseX = event.pageX - container.offset().left;
            var mouseY = event.pageY - container.offset().top;
            
            // Calculate percentages
            var percentX = mouseX / container.width() * 100;
            var percentY = mouseY / container.height() * 100;
            
            // Move the image within the container based on mouse position
            var imgWidth = img.data('orig-width');
            var imgHeight = img.data('orig-height');
            
            var moveX = (imgWidth - container.width()) * (percentX / 100);
            var moveY = (imgHeight - container.height()) * (percentY / 100);
            
            img.css({
                'transform-origin': percentX + '% ' + percentY + '%',
                'transform': 'scale(1.2) translate(' + -moveX + 'px, ' + -moveY + 'px)'
            });
            });
        }
      });
    
      $('.image-container').on('mouseleave', function() {
        if ($(window).width() > 960) {
            var img = $(this).find('img');
            
            // Reset transform properties
            img.css({
            'transform': 'none',
            'transform-origin': 'initial'
            });
            
            // Remove mousemove event handler
            $(this).off('mousemove');
        }
      });
});
